import { faDownload, faEllipsis, faL } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { FaMobileAlt } from "react-icons/fa";
import fileDownload from "js-file-download";
import axios from "axios";
import Loader from "../Loader/Loader";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
function SiteStatus({ BaseUrl }) {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("TOKEN")}`,
    withCredentials: true,
    
  };
  const [conunt, setcount] = useState(0);
  const [loading, setloding] = useState(false);
  const Hanadler_DownloadApplication = (filename) => {
    setloding(true);
    axios
      .get(`${BaseUrl}/phone/download`, {
        headers: headers,
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
        setloding(false);
        console.log(res, "lllllll");
      })
      .catch((err) => {
        setloding(false);
        NotificationManager.error("مشکلی رخ داده است");
      });
  };
  const CounterPhone = () => {
    axios
      .get(`${BaseUrl}/phone/all`, { headers: headers })
      .then((res) => {
        setcount(res.data.Phones.length);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    CounterPhone();
  }, [conunt]);
  return (
    <>
      <div className="text-4xl text-orange-700 mb-5  w-1/12 rounded-l-xl bg-slate-700 text-center relative left-8 p-1 mt-10">
        داشبورد
      </div>
      <div className="w-12/12 m-auto flex  justify-evenly items-center p-4">
        <div className="w-4/12 bg-white rounded-md shadow-md shadow-slate-200 h-32">
          <div class="h-full rounded-lg bg-sky400 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] dark:bg-neutral-700 jus">
            <div class="p-6 flex justify-evenly items-center">
              <h5 class="mb-2 text-xl font-medium leading-tight align-middle text-white dark:text-neutral-50 ">
                دانلود نصب اپلیکشن
              </h5>
              <FontAwesomeIcon
                icon={faDownload}
                className=" text-4xl items-center text-white"
              />
            </div>
            <button
              className={`border text-white  w-1/2 m-auto bg-gradient-to-r ${
                loading
                  ? "from-orange-400 to-red-400"
                  : "from-orange-500 to-red-500"
              } rounded-md h-12 mt-5 text-center relative flex justify-center items-center cursor-pointer`}
              onClick={() =>
                Hanadler_DownloadApplication("instagram-314-0-0-20-114.apk")
              }
            >
              {loading ? <Loader /> : "دانلود برنامه"}
            </button>
          </div>
        </div>
        <div className="w-4/12 bg-white rounded-md shadow-md shadow-slate-200 h-32">
          <div class="h-full rounded-lg bg-sky400 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] dark:bg-neutral-700 jus">
            <div class="p-6 flex justify-evenly items-center">
              <h5 class="mb-2 text-xl font-medium leading-tight align-middle text-white dark:text-neutral-50">
                تعداد گوشی‌های موجود در پنل
              </h5>
              <FaMobileAlt className="text-4xl items-center text-white" />
            </div>
            <div className="border  w-1/2 m-auto bg-gradient-to-r from-orange-500 to-red-500 rounded-md h-12 mt-5 text-center relative flex justify-center items-center cursor-pointer">
              <h1 className="text-3xl text-white">{conunt}</h1>
            </div>
          </div>
        </div>
        <NotificationContainer />
      </div>
    </>
  );
}

export default SiteStatus;
